"use strict";
export { BreadcrumbCurrentLink as CurrentLink, BreadcrumbEllipsis as Ellipsis, BreadcrumbItem as Item, BreadcrumbLink as Link, BreadcrumbList as List, BreadcrumbPropsProvider as PropsProvider, BreadcrumbRoot as Root, BreadcrumbSeparator as Separator } from './breadcrumb.js';
